module.exports = __WEBPACK_EXTERNAL_MODULE_23__;


//////////////////
// WEBPACK FOOTER
// external "isogd-document-link-rest"
// module id = 23
// module chunks = 0